import { render, staticRenderFns } from "./c_page_ueditor.vue?vue&type=template&id=196e940a&scoped=true"
import script from "./c_page_ueditor.vue?vue&type=script&lang=js"
export * from "./c_page_ueditor.vue?vue&type=script&lang=js"
import style0 from "./c_page_ueditor.vue?vue&type=style&index=0&id=196e940a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e940a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196e940a')) {
      api.createRecord('196e940a', component.options)
    } else {
      api.reload('196e940a', component.options)
    }
    module.hot.accept("./c_page_ueditor.vue?vue&type=template&id=196e940a&scoped=true", function () {
      api.rerender('196e940a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_page_ueditor.vue"
export default component.exports